
$(document).ready(function(){
    $(document).on("click", ".main-blog p.tab-mobile", function () {
    $(this).toggleClass("active");
$(".desktop-all-tag").slideToggle();
  });
  $(document).on("click", ".desktop-all-tag p.main-tag", function () {
  const nextDiv = $(this).next(".content-tag");

  // If this tag has no dropdown div, do nothing
  if (nextDiv.length === 0) return;
 $(".desktop-all-tag p.main-tag").not(this).removeClass("active");
  // Hide all other dropdowns
  $(".desktop-all-tag .content-tag").not(nextDiv).slideUp();

  // Toggle only the clicked one
  nextDiv.slideToggle();
  $(this).toggleClass("active");
});
   $('.main-content-slider-section-hair-care').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  infinite:true,
     dots:true,
     appendDots: $('.section-hair-care .custom-arrows-sl'),
 responsive: [                        
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,

        }
      },
      {
        breakpoint: 577,
        settings: {
          dots: true,
          infinite:false,
          slidesToShow: 1.6,
        }
      },
  ]
});
  $(document).on('click', '.main-par-mul-c-tab .top-tab-bl-c p', function() {
    $(".main-par-mul-c-tab .top-tab-bl-c p").removeClass("active");
    $(this).addClass("active");
    var datatabatr = $(this).attr("data-id");
    $(".main-par-mul-c-tab .single-block-tab").removeClass("active");
    $(".main-par-mul-c-tab .single-block-tab#"+datatabatr).addClass("active");

  });
  $(document).on('click', '.main-content-slider-section-hair-care video', function() {
    $(".main-content-slider-section-hair-care video").not($(this)).trigger("pause");
    var clickedVideoplay = this;
    if (clickedVideoplay.paused) {
    clickedVideoplay.play();
  } else {
    clickedVideoplay.pause();
  }
  });
    $(".section-hair-care .main-content-slider-section-hair-care").on("afterChange",function (event, slick, currentSlide, nextSlide) {
      $(".section-hair-care .main-content-slider-section-hair-care video").trigger("pause");
  });
  
  $('.homepage-coll-slider ul.product-grid').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  infinite:false,
 responsive: [                        
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,

        }
      },
      {
        breakpoint: 577,
        settings: {
          dots: true,
          slidesToShow: 1.37,
        }
      },
  ]
});


 
  function updateSubscriptionUI() {
    let activePlanIndex = $('.prive-plan-option__input:checked').closest('.prive-plan-option').index() + 1;
    if (activePlanIndex === 0) activePlanIndex = 1; 
    $(".sub-time-cost").each(function() {
      var dataAttrValue = $(this).data("val-sub-" + activePlanIndex);
      if (dataAttrValue !== undefined) {
        $(this).text(dataAttrValue);
      }
    });
  }

  $(document).on('change', '.prive-option__input', function() {
    if ($(this).val() === 'subscribe') {
      $("span.option-ser-data.sub-time-cost").show();
      $("span.option-ser-data.one-time-cost").hide();
      updateSubscriptionUI();
    } else {
      $("span.option-ser-data.sub-time-cost").hide();
      $("span.option-ser-data.one-time-cost").show();
    }
  });

  $(document).on('change', '.prive-plan-option__input', function() {
    updateSubscriptionUI();
  });
  if ($('.prive-option__input:checked').length) {
    $('.prive-option__input:checked').trigger('change');
  }


  
 



 
  
//   var value = $("header.header").outerHeight();
// $("body").append('<style>.link-with-hover:after{height: ' + value + 'px;}</style>');
  $(".header #menu-drawer .close-menu-btn svg").on("click",function(){
    $("header header-drawer details summary").first().click();
  });
  if($(".ultimate-choice-section").length > 0){

//   $(window).scroll(function() {
//     var maintop = $('.ultimate-choice-section').offset().top;
//     if ($(this).scrollTop() > maintop){ 
//         $('.ultimate-choice-section').addClass("animation");
//         setTimeout(function(){
//            $('.ultimate-choice-section').removeClass("animation");
//         }, 5000); 
//       }
//       else{
//        $('.ultimate-choice-section').removeClass("animation");
//       }
// });
  }
  $('a.atc_top_btn').on("click",function(){
    if ($(window).width() < 750) {
      $("html, body").animate({
        scrollTop:  $('.product product-info').offset().top + 100
    }, 1000); 
    }
    else{
    $("html, body").animate({
        scrollTop:  $('.product product-info').offset().top - $('header').outerHeight()
    }, 1000); 
    }
  });
   $('.product-multicolumn .multicolumn-list, .section-insta-landing .parent-div-instagram-data').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
  });
  $('.product-happy-multicolumn-section .multicolumn-list').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      dots: true,    
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4
          }
        },       
        {
          breakpoint: 768,
          settings: {          
            slidesToShow: 3.5
          }
        },
        {
          breakpoint: 481,
          settings: {
            variableWidth: true,
            slidesToShow: 3.5
          }
        },
        {
          breakpoint: 360,
          settings: {
            variableWidth: true,
            slidesToShow: 3
          }
        }
      ]
});
  // $(window).on('load', function() {   
  //   if($('.product-multicolumn .multicolumn-list ul.slick-dots li,.product-happy-multicolumn-section .multicolumn-list ul.slick-dots li').length == 1 ){
  //     $('.product-multicolumn .multicolumn-list ul.slick-dots,.product-happy-multicolumn-section .multicolumn-list ul.slick-dots').css('display','none');
  //   }else{
  //     $('.product-multicolumn .multicolumn-list ul.slick-dots,.product-happy-multicolumn-section .multicolumn-list  ul.slick-dots').css('display','flex');
  //   }

  //   if($('.section-insta-landing .parent-div-instagram-data ul.slick-dots li,.product-happy-multicolumn-section .multicolumn-list li').length == 1 ){
  //     $('.section-insta-landing .parent-div-instagram-data ul.slick-dots,.product-happy-multicolumn-section .multicolumn-list ul.slick-dots').css('display','none');
  //   }else{
  //     $('.section-insta-landing .parent-div-instagram-data ul.slick-dots,.product-happy-multicolumn-section .multicolumn-list ul.slick-dots').css('display','flex');
  //   }
  // });
  
  // $(window).on('resize', function() {   
  //   if($('.product-multicolumn .multicolumn-list ul.slick-dots li,.product-happy-multicolumn-section .multicolumn-list ul.slick-dots li').length == 1 ){
  //     $('.product-multicolumn .multicolumn-list ul.slick-dots,.product-happy-multicolumn-section .multicolumn-list ul.slick-dots').css('display','none');
  //   }else{
  //     $('.product-multicolumn .multicolumn-list ul.slick-dots,.product-happy-multicolumn-section .multicolumn-list ul.slick-dots').css('display','flex');
  //   }

  //   if($('.section-insta-landing .parent-div-instagram-data ul.slick-dots li,.product-happy-multicolumn-section .multicolumn-list ul.slick-dots li').length == 1 ){
  //     $('.section-insta-landing .parent-div-instagram-data ul.slick-dots,.product-happy-multicolumn-section .multicolumn-list ul.slick-dots').css('display','none');
  //   }else{
  //     $('.section-insta-landing .parent-div-instagram-data ul.slick-dots,.product-happy-multicolumn-section .multicolumn-list ul.slick-dots').css('display','flex');
  //   }
  // });
  $('.play-pause-marquee svg').on("click",function(){ 
    if($(this).hasClass("pause-svg")){
      $(this).parents(".play-pause-marquee").find("svg.play-svg").addClass("active-svg");
      $(this).parents(".play-pause-marquee").find("svg.pause-svg").removeClass("active-svg");
    }
    else{
       $(this).parents(".play-pause-marquee").find("svg.pause-svg").addClass("active-svg");
      $(this).parents(".play-pause-marquee").find("svg.play-svg").removeClass("active-svg");
    }
    $(this).parents(".section-marquee").find(".marquee-animation-ul").toggleClass("pause-marquee-ul");
    $(this).parents(".product_mulcol2_section").find(".marquee-animation-ul").toggleClass("pause-marquee-ul");
  });
 $('.play-pause-ultimate svg').on("click",function(){
    if($(this).hasClass("pause-svg")){
      $(this).parents(".play-pause-ultimate").find("svg.play-svg").addClass("active-svg");
      $(this).parents(".play-pause-ultimate").find("svg.pause-svg").removeClass("active-svg");
    }
    else{
       $(this).parents(".play-pause-ultimate").find("svg.pause-svg").addClass("active-svg");
      $(this).parents(".play-pause-ultimate").find("svg.play-svg").removeClass("active-svg");
    }
   $(this).parents(".ultimate-choice-section").toggleClass("animation");      
 });
$(".option-product-all p").on("click",function(){
  var selectedcolor=[]
   $(this).parents(".grid__item").find(".variant-all option").each(function () {
                var optid = $(this).attr("option-id");               
            });
  $(this).parent().find("p").removeClass("active-color");
  $(this).addClass("active-color");
   $(this).parents(".grid__item").find(".each-option-value").each(function(){
     selectedcolor.push(" "+$(this).find(".active-color").text());
   });
  var colorname = selectedcolor.toString().split(",").join("");
  $(this).parents(".grid__item").find("select.variant-all").val(colorname);
  $(this).parents(".grid__item").find("select.variant-all").change();
  
  var finalprice = $(this).parents(".grid__item").find("select.variant-all").find(":selected").attr("data-var-price");
   $(this).parents(".grid__item").find(".price-item").text(finalprice);
  var finalimage = $(this).parents(".grid__item").find("select.variant-all").find(":selected").attr("data-var-img");
   $(this).parents(".grid__item").find(".image-variants img").attr("src",finalimage);
  var finallink = $(this).parents(".grid__item").find("select.variant-all").find(":selected").attr("data-var-link");
  $(this).parents(".grid__item").find(".card-link-variant").attr("href",finallink);
  $(this).parents(".grid__item").find("a.quick-add__submit").attr("href",finallink);
  });
 if ($(window).width() < 750) {
$(".store-locator-nation ul").slick({
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: true,
      dots: true,
      infinite: false,
      appendArrows: $('.store-locator-nation .slick-slider-nav'),
    appendDots: $('.store-locator-nation .slick-slider-dots'),
    prevArrow: "<button class='slick-prev btn btn-white rounded-circle'><svg xmlns='http://www.w3.org/2000/svg' width='49' height='49' viewBox='0 0 49 49' fill='none'><path d='M15.7929 25.151C15.4024 24.7604 15.4024 24.1273 15.7929 23.7367L22.1569 17.3728C22.5474 16.9823 23.1805 16.9823 23.5711 17.3728C23.9616 17.7633 23.9616 18.3965 23.5711 18.787L17.9142 24.4438L23.5711 30.1007C23.9616 30.4912 23.9616 31.1244 23.5711 31.5149C23.1805 31.9054 22.5474 31.9054 22.1569 31.5149L15.7929 25.151ZM34.5 25.4438H16.5V23.4438H34.5V25.4438Z' fill='#1B1B1B'/><circle cx='24' cy='24' r='23.5' transform='matrix(-1 0 0 1 48.5 0.443848)' stroke='#1B1B1B'/></svg></button>",
    nextArrow: "<button class='slick-next btn btn-white rounded-circle'><svg xmlns='http://www.w3.org/2000/svg' width='49' height='49' viewBox='0 0 49 49' fill='none'><path d='M33.2071 25.151C33.5976 24.7604 33.5976 24.1273 33.2071 23.7367L26.8431 17.3728C26.4526 16.9823 25.8195 16.9823 25.4289 17.3728C25.0384 17.7633 25.0384 18.3965 25.4289 18.787L31.0858 24.4438L25.4289 30.1007C25.0384 30.4912 25.0384 31.1244 25.4289 31.5149C25.8195 31.9054 26.4526 31.9054 26.8431 31.5149L33.2071 25.151ZM14.5 25.4438H32.5V23.4438H14.5V25.4438Z' fill='#1B1B1B'/><circle cx='24.5' cy='24.4438' r='23.5' stroke='#1B1B1B'/></svg></button>"
});
 }
function addBodyClass() { 
    if (!$('.slider-main-drawer').hasClass('slick-initialized')) {
       $('.slider-main-drawer').slick({
  slidesToShow: 1.45,
  slidesToScroll: 1,
  arrows:false,
  infinite:false
});
    }
  }
  setInterval(addBodyClass, 1000);
 $('.slider-main-drawer').slick({
  slidesToShow: 1.45,
  slidesToScroll: 1,
  arrows:false,
  infinite:false 
});
   $(document).on("click", "#CartDrawer-Overlay", function () {
  
    $("cart-drawer").removeClass("active");
    $("body").removeClass("overflow-hidden");
     $("#buysafeRollover").click();
});
  $(document).on("click", "cart-drawer button.drawer__close", function () {
  $("#buysafeRollover").click();
});
 $(".product .product-quantity-select").on("change",function(){ 
    var count = parseInt($(this).val()) + 1;
    var comparePrice = $('.compare-price').data('compare-price');

    $(this).parents(".product").find(".price-per-item__container input").val($(this).val());
    $(".product #quantity-wrapper").val(parseInt($(this).val()) + 1);
    
    setTimeout(function(){   
      $('.product .quantity__button[name="plus"]').click();
      var finalPrice = comparePrice*count
      $('.compare-price').html('$ '+finalPrice+' USD');
    }, 500);  
  });
  // $('.product quantity-input button').on("click",function(){
  //   setTimeout(function(){
  //   $(".product #quantity-wrapper").val($(this).parent().find(".quantity__input").val());
  //     },700);
  // });
// var varianttop= $(".product .product__title").height() + 30;
//   if ($(window).width() < 750) {
//   var variantmargin=$(".product fieldset.js.product-form__input.size-option-pdp").height() + 18;
//     var varianttop= $(".product .product__title").height() + 48;
//   }
//   else{
//     var variantmargin=$(".product fieldset.js.product-form__input.size-option-pdp").height() + 12;
//   var varianttop= $(".product .product__title").height() + 30;
//   }
//   $(".product fieldset.js.product-form__input.size-option-pdp").css("top",varianttop+"px");
// $(".product .product__title").css("margin-bottom",variantmargin+"px");

  $(".review-section-pdp").parent().addClass("section-review-section-pdp");

// $(".prive_select").change(function(){
//   setTimeout(function(){
//      $(".product span.variant-price-button").text($(this).parents(".prive_type_box").find(".prive_label span").eq(2).text());
//     },1000);
// })

  // $(".product .slider-button").on("click",function(){
  //   $(".thumbnail-slider .thumbnail-list__item.show-product-li").each(function(){
  //     if($(this).find("button").attr("aria-current") == "true"){
  //       $(this).next(".show-product-li").find("button").click();
  //       $(this).next(".show-product-li").find("button").addClass("asasasasas");
  //     }
  //   })
  // })
$('.main-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,  
    dots:false,
   infinite:false,
  focusOnSelect: true, 
  asNavFor: '.nav-slider',
       appendArrows: $('.slick-slider-main-arrow'),
    prevArrow: "<button class='slick-prev btn btn-white rounded-circle'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M20 26.6667L9.33333 16.0001L20 5.33341' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    nextArrow: "<button class='slick-next btn btn-white rounded-circle'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M12 26.6667L22.6667 16.0001L12 5.33341' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
  responsive: [
    {
      breakpoint: 750,
      settings: {
        dots:true,
        
       
      }
    }
    ]
});
$('.nav-slider').slick({
   slidesToShow: 6,
  slidesToScroll: 1,
  draggable:true,
  focusOnSelect: true,  
  arrows: false,
infinite:false,  
  asNavFor: '.main-slider',  
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,    
      }
    },    
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,       
      }
    },
    ]
});  
  if ($(window).width() < 1200) {
  var numSlides = $(".nav-slider-product li").length;
     if (numSlides < 5 ) {
     $('.nav-slider-product').addClass('small-slides');
      }
  }
    else{
      var numSlides = $(".nav-slider-product li").length;
     if (numSlides < 7 ) {
     $('.nav-slider-product').addClass('small-slides');
      }
    }
  
$(".size-dropdown-parent").on("click",function(){
  $(this).parents(".size-option-with-dropdown").find(".size-option-details").slideToggle();
  $(this).toggleClass("active-size-variant");
})
$(".size-option-details p").on("click",function(){
  var variantsize=$(this).attr("data-value-size");
  $(".product fieldset.size-option-pdp label").each(function(){
    if($(this).attr("data-label")  == variantsize){
      $(this).click();
    }
  })
  $(".product .selected-size-pdp").text(variantsize);
})
  $(document).on('click', function (event) {
  if (!$(event.target).closest('.size-option-with-dropdown').length) {
    if($(".size-dropdown-parent").hasClass("active-size-variant")){
      $(".size-dropdown-parent").removeClass("active-size-variant");
      $(".size-option-details").slideUp();
    }
  }
});
//pdp drop down
    var menu = document.querySelector('.variants_meta_menu');
  var content = document.querySelector('.variant_tab_content');
  if($(".variants_meta_menu").length > 0){
  document.querySelector('.variants_meta_select').addEventListener('click', function() {
    menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
  });
  var listItems = document.querySelectorAll('.variants_meta_menu li');
  listItems.forEach(item => {
    item.addEventListener('click', function() {
        var id = this.getAttribute('rel');
      var newcon = document.getElementById(id);
      var div_id = newcon.getAttribute('id');
      var list_val = this.innerText;
var span = document.querySelector('.variants_meta_select');
span.textContent = list_val 
      document.querySelectorAll('.variant_tab_content').forEach((el) => {    el.classList.remove('active');});
if(id == div_id){
    newcon.classList.add('active');
  this.classList.add('active');
  document.querySelector('.variants_meta_menu').style.display = "none";
}  
    }); 
  });
  }
 var seenText = {};
$("ul.variants_meta_menu li").each(function() {
    var liText = $(this).text().trim();

    if (seenText[liText]) {
       $(this).hide();
    } else {
      seenText[liText] = true;
    }
  }); 
$(document).on("click","cart-drawer p.bundle-product-remove",function(e) {
  var lengthbundle=$("cart-drawer .cart-drawer .cart-item.bundle-cart-product").length;
  //   $("cart-drawer .cart-drawer .cart-item.bundle-cart-product").each(function(index){
      
  //     var lineidcart=parseInt($(this).attr("data-product-index"));
  //     $.ajax({
  //       url: "/cart/change.js",
  //       type: "post",
  //       dataType: 'json',
        
  //       data: {
  //         id: lineidcart,
  //         quantity:0
  //       },
  //       async: false,
  //   success: function (cart) {
  //     if (index === (lengthbundle - 1)){
  // 		alert('Last index');
  //     }
  //   },
  //       error: function (err) {}
      
  // });
  
   var updatedata =  $(".update-data").attr("data-attr-all");
              jQuery.post(window.Shopify.routes.root + 'cart/update.js',
        updatedata
        );
  setTimeout(function(){
  drawerfunction();  
         $("cart-drawer").load(location.href + " cart-drawer>*","");
  $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");
    
  },1500);
   setTimeout(function(){
drawerfunction();
     if($("cart-drawer .cart-drawer .cart-item").length == 0){
    $("cart-drawer").addClass("is-empty");
  }
   },3000);
 
  setTimeout(function(){
  
},3000);
  setTimeout(function(){
    drawerfunction()
  $("cart-drawer").load(location.href + " cart-drawer>*","");
  $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");
   },4000);
setTimeout(function(){
  if($("cart-drawer .cart-drawer .cart-item").length == 0){
    $("cart-drawer").addClass("is-empty");
  }
},4000);
  setTimeout(function(){
  if($("cart-drawer .cart-drawer .cart-item").length == 0){
    $("cart-drawer").addClass("is-empty");
  }
},4200);
  setTimeout(function(){
  if($("cart-drawer .cart-drawer .cart-item").length == 0){
    $("cart-drawer").addClass("is-empty");
  }
},5000);
   setTimeout(function(){
  if($("cart-drawer .cart-drawer .cart-item").length == 0){
    $("cart-drawer").addClass("is-empty");
  }
},7000);
  setTimeout(function(){
  if($("cart-drawer .cart-drawer .cart-item").length == 0){
    $("cart-drawer").addClass("is-empty");
  }
},9000);
  //   });

  
});

  $('.max_out_block .max_out_toggle').on('click',function () {
    $(this).toggleClass('a_show');
    $(this).next().toggle();   
  });

  $(".instagram-app-section").parent().addClass("instagram-app-section");
  if (window.location.href.indexOf("/cart") > -1) {
    window.location = "/";
  }

  $('.var-radioa').on('click', function(){
    var option = $(this).data('op-title');

    $(".product-stock > option").each(function() {
        // console.log($(this).data('variant-title'));
      if($(this).data('variant-title').indexOf(option) != -1){
          console.log($(this).data('variant-title'));
          var varId = $(this).val();
          var currentUrl = window.location.href;
          var newurllink = new URL(currentUrl);
  
        if(currentUrl.indexOf('variant') != -1){
          newurllink.searchParams.set("variant", varId); // setting your param
          window.location = newurllink.href; 
        }
        return false;
      }
    });
  })

$('.ugc-slider').on('init', function(event, slick){
// alert('sdfgfg')
    $('.ugc-slider').show();
    $('.loader_ugc').hide();

});

$('.ugc-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  centerMode: true,
  variableWidth: true,
  infinite: true,
  focusOnSelect: true,
  // cssEase: 'linear',
  touchMove: false,
  prevArrow:'<button class="slick-prev"> < </button>',
  nextArrow:'<button class="slick-next"> > </button>',
  
  responsive: [                        
      {
        breakpoint: 750,
        settings: {
          dots: true,
          arrows:false
        }
      },
      {
        breakpoint: 576,
        settings: {
          // centerMode: true,
          // variableWidth: true,
          // slidesToShow: 1,
          // slidesToScroll: 1,
          dots: true,
              arrows:false
        }
      },
  ]
});

// var imgs = $('.slider img');
// imgs.each(function(){
//   var item = $(this).closest('.item');
//   item.css({
//     'background-image': 'url(' + $(this).attr('src') + ')', 
//     'background-position': 'center',            
//     '-webkit-background-size': 'cover',
//     'background-size': 'cover', 
//   });
//   $(this).hide();
// });



// class Videos {
//   constructor(el) {
//     this.element = $(el);
//     this.video = this.element.find(".single-video")[0];

//     console.log(this.element);
//     this.element.on('click', this.toggleVideo);
//   }

//   toggleVideo = () => {
//     if (this.video.paused) {
//       this.playVideo();
//     } else {
//       this.pauseVideo();
//     }
//   }

//   playVideo() {

//       // var otherVideos = document.querySelector('single-video')[0];
//       // document.querySelectorAll('.vid_se_val').classList.add("get-icon");
//       document.querySelectorAll('.single-video').forEach(vid => vid.pause());

//       var list;
//       list = document.querySelectorAll(".vid_se_val");
//       for (var i = 0; i < list.length; ++i) {
//          list[i].classList.add('get-icon');
//       }

//       // otherVideos.pause();
//       this.video.muted = false; // Unmute the video
//       this.video.controls = false; // Hide controls
//       this.video.play();
    
    
//     this.element.find(".video-comp-poster").addClass("video__poster--hide");
//     this.element.find(".vid_se_val").removeClass("get-icon");
//   }

//   pauseVideo() {
  
//       this.video.pause();
   
//       this.element.find(".vid_se_val").addClass("get-icon");
//   }
// }

// $('[data-behaviour="video"]').map((i, el) => new Videos(el));

// $('.ugc-slider .item').on('click', function(){
// setTimeout(function(){
// if($(this).hasClass('video-played')){



// console.log('werewrwer1111')
//     $(this).removeClass('video-played');
//     // $(this).find('.video-comp-poster').show();
//     var video = $(this).find('.video-comp-video').get(0);
// console.log(video)
    
// video.play();
// }
// else{
// console.log('werewrwer3333')
//     $(this).addClass('video-played');
//     $(this).find('.video-comp-poster').hide();
//     var video = $(this).find('.video-comp-video').get(0);
//      video.pause();
// }
// }, 2000); 
// });
// $('.ugc-slider .slick-next,.ugc-slider .slick-prev').on('click', function(){
// $('.ugc-slider .item').find('.video-comp-poster').show();
//    if($('.ugc-slider .item').hasClass('video-played')){
//       $('.video-played').find('.video-comp-video').get(0).pause();
//       $('.video-played').find('.video-comp-video').get(0).currentTime = 0;
//       $('.video-played').find('.video-comp-poster').show();
//    }

// $('.ugc-slider .slick-slide').css('visibility', 'visible');

// var hideIndex = $('.ugc-slider .slick-current').data('slick-index') - 3;
// $('.ugc-slider .slick-slide[data-slick-index='+hideIndex+']').css('visibility', 'hidden');

//     $('.ugc-slider .item').removeClass('video-played');
//     $('.ugc-slider .slick-current').addClass('video-played');

//     $('.ugc-slider .slick-current').find('.video-comp-poster').hide();
//     var video = $('.ugc-slider .slick-current').find('.video-comp-video').get(0);
//     video.play();
// $('.ugc-slider .item').find('.video-comp-video').hide();
// $('.ugc-slider .slick-current').find('.video-comp-video').show();
// });

$(document).on('afterChange' ,'.ugc-slider' , function (event, slick, currentSlide){
 // $('.ugc-slider').on('afterChange', function (event, slick, currentSlide) {
// $('.ugc-slider .slick-next,.ugc-slider .slick-prev').on('click', function(){
console.log('dfgfdgd')
if($('.ugc-slider .slick-current').hasClass('video-played')){
console.log('frust')
$('.ugc-slider .slick-current').removeClass('video-played');
}
else{
   $('.ugc-slider .item').find('.video-comp-poster').show();
   if($('.ugc-slider .item').hasClass('video-played')){
      $('.video-played').find('.video-comp-video').get(0).pause();
      $('.video-played').find('.video-comp-video').get(0).currentTime = 0;
      $('.video-played').find('.video-comp-poster').show();

   }

   $('.ugc-slider .slick-slide').css('visibility', 'visible');

   var hideIndex = $('.ugc-slider .slick-current').data('slick-index') - 3;
   $('.ugc-slider .slick-slide[data-slick-index='+hideIndex+']').css('visibility', 'hidden');

   $('.ugc-slider .item').removeClass('video-played');
   $('.ugc-slider .slick-current').addClass('video-played');

   $('.ugc-slider .slick-current').find('.video-comp-poster').hide();
   var video = $('.ugc-slider .slick-current').find('.video-comp-video').get(0);
   video.play();
   $('.ugc-slider .item').find('.video-comp-video').hide();
   $('.ugc-slider .slick-current').find('.video-comp-video').show();
}
});

  if ($('.ugc-slider').isInViewport()) {
       $('.ugc-slider .slick-current').find('.video-comp-poster').hide();
       $('.ugc-slider .slick-current').addClass('video-played');
       var firstvideo = $('.ugc-slider .slick-current').find('.video-comp-video').get(0);
       firstvideo.play(); 
    }
  
$(window).on('resize scroll', function() {
    if ($('.ugc-slider').isInViewport()) {
       $('.ugc-slider .slick-current').find('.video-comp-poster').hide();
       $('.ugc-slider .slick-current').addClass('video-played');
      // var firstvideo = $('.ugc-slider .slick-current').find('.video-comp-video').get(0);
      //  firstvideo.play(); 
    }
});

$('.ugc-slider .item').find('.video-comp-video').hide();
$('.ugc-slider .slick-current').find('.video-comp-video').show();


});

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};


function videoEnd(){
console.log('rghrgw')
if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) { /* Safari */
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) { /* IE11 */
    document.msExitFullscreen();
  }
var nextslide = $('.ugc-slider .slick-current').data('slick-index')+ 1;
$('.ugc-slider').slick('slickGoTo', nextslide);
    // $('.ugc-slider .slick-next').trigger('click');
$('.ugc-slider .item').removeClass('video-played');
 
var video = $('.ugc-slider .slick-current').find('.video-comp-video').get(0);
   video.play(); 
setTimeout(function(){ 
$('.ugc-slider .slick-current').addClass('video-played');
$('.ugc-slider .slick-current').find('.video-comp-video').show();
 }, 500);
  }
$(document).ready(function() {
var video = $(".ugc-slider video");

        // Function to handle fullscreen change
        function handleFullscreenChange() {
           if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
                $('body').addClass('fullscreen');
            } else {
                $('body').removeClass('fullscreen');
            }
        }

        // Event listener for fullscreen change
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);




  $(document).on("click", ".discount_code_remove", function () { 
      var discountCode = document.getElementById("discount_code").value;
      console.log(discountCode);
      fetch('/discount/'+discountCode)
        .then(function() {
            fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              updates: {},
            }),
          }).then(cart => {
               $("cart-drawer").load(location.href + " cart-drawer>*","");
  $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");
              setTimeout(function(){
              drawerfunction();
              },1999);
              setTimeout(function(){
           
  $("cart-drawer").load(location.href + " cart-drawer>*","");
  $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");
   
              },4000);
          })
          .catch(error => {
            console.error('Error updating cart:', error);
          });
          document.getElementById("discount_code").value = '';
        })
        .catch(function(error) {
          console.error('Error:', error);
        });
    });
    // old removed by shopify
  //   $(document).on('click','.discount-remove', function() {
  //     fetch('/discount/CLEAR')
  //         .then(function() {
  //             fetch('/cart/update.js', {
  //             method: 'POST',
  //             headers: {
  //               'Content-Type': 'application/json'
  //             },
  //             body: JSON.stringify({
  //               updates: {},
  //             }),
  //           }).then(cart => {
  //           $("cart-drawer").load(location.href + " cart-drawer>*","");
  // $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");
  //             setTimeout(function(){
  //             drawerfunction();
  //             },1999);
  //             setTimeout(function(){
           
  // $("cart-drawer").load(location.href + " cart-drawer>*","");
  // $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");
   
  //             },4000);
  
  //           })
  //           .catch(error => {
  //             console.error('Error updating cart:', error);
  //           });
  //           document.getElementById("discount_code").value = '';
  //         })
  //         .catch(function(error) {
  //           console.error('Error:', error);
  //         });
  //   });
  $(document).on('click','.discount-remove', function() {
     fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      discount: ''
    })
  })
  .then(res => res.json())
  .then(cart => {
 $("#discount_code").css("opacity", "0");
document.getElementById("discount_code").value = 'aa';
 $(".discount_code_remove").click();
  
  });    
});
    });

function pressEsc() {
    $('body').trigger({
        type: 'keyup',
        which: 27 // Escape key
    });



  
}